import { Box, CircularProgress, Typography } from "@mui/material";
import type { JSX } from "react";

export default function LoadingIndicator(): JSX.Element {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <CircularProgress size={16} />
      <Typography component="strong" fontWeight="bold">
        Loading...
      </Typography>
    </Box>
  );
}
